<template>
  <div class="table-page">
    <vue-table :table-data="tableData" ref="vueTable">
      <template slot="searchBar">
        <el-form-item label="状态">
          <el-select v-model="tableData.search.status" clearable>
            <el-option v-for="item in commonStatusBoole" :key="item.id" :value="+item.id" :label="item.msg"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号">
          <el-input v-model.trim="tableData.search.username" clearable></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model.trim="tableData.search.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model.trim="tableData.search.mobile" clearable></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model.trim="tableData.search.email" clearable></el-input>
        </el-form-item>
      </template>
      <template slot="operateBar">
        <el-button v-if="checkApi('addAdmin')" size="small" type="primary" @click="add">添加</el-button>
      </template>
      <template slot="location" slot-scope="{row}">{{formatLocation(row)}}</template>
      <template v-if="hasApi(['getAdminPermission','modifyAdmin','deleteAdmin','pwdAdmin'])" slot="actionBar">
        <el-table-column align="center" label="操作栏" :resizable="false" width="220">
          <template slot-scope="{row}">
            <el-button v-if="checkApi('getAdminPermission')" type="text" @click="showPermission(row)" :disabled="!row.adm_role_id">查看权限</el-button>
            <el-button v-if="checkApi('pwdAdmin')" type="text" @click="reset(row)">重置密码</el-button>
            <el-button v-if="checkApi('modifyAdmin')" type="text" @click="modify(row)" :disabled="row.is_super">修改</el-button>
            <el-button v-if="checkApi('deleteAdmin')" type="text" @click="remove(row)" :disabled="row.is_super">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </vue-table>
    <table-operate v-if="tableOperate.visible" :dialog-data="tableOperate" @getData="getData"/>
    <admin-permission v-if="adminPermission.visible" :dialog-data="adminPermission"/>
    <reset-pwd v-if="resetPwd.visible" :dialog-data="resetPwd"/>
  </div>
</template>

<script>
import TableOperate from "./dialog/TableOperate"
import AdminPermission from "./dialog/AdminPermission"
import ResetPwd from "./dialog/ResetPwd"
import {commonStatusBoole} from "@utils/formatList"
export default {
  name: "deviceList",
  components: {TableOperate,AdminPermission,ResetPwd},
  data() {
    return {
      commonStatusBoole,
      tableData: {
        tableList: [],
        tableColumn: [
          {label: "ID", property: "id", width: 60},
          {label: "状态", property: "status", width: 70, format: commonStatusBoole},
          {label: "账号", property: "username"},
          {label: "姓名", property: "name"},
          {label: "手机号", property: "mobile", width: 100},
          {label: "所属角色", property: "adm_role.name"},
          {label: "登录时间", property: "login_at"},
          {label: "登录IP", property: "login_ip"},
          {label: "登录位置", property: "location"},
          {label: "登录次数", property: "login_count", width: 80},
          {label: "备注", property: "remark"},
        ],
        api: "getAdminList",
        search: {
          status: "",
          username: "",
          name: "",
          mobile: "",
          email: "",
          role_name: "",
        }
      },
      tableOperate: {visible: false, title: "", row: null},
      resetPwd: {visible: false, title: "重置密码", row: null},
      adminPermission: {visible: false, title: "管理员权限", row: null, hideBtn: true, width: 750},
    }
  },
  methods: {
    add() {
      this.tableOperate.title = "添加";
      this.tableOperate.visible = true;
      this.tableOperate.row = null;
    },
    modify(row) {
      this.tableOperate.title = "修改";
      this.tableOperate.visible = true;
      const nv = {...row};
      nv.status = +nv.status;
      this.tableOperate.row = nv;
    },
    remove(row) {
      this.openConfirm("删除该项", async ()=> {
        let nv = {};
        nv.admin_id = row.id;
        let res = await this.$Http.deleteAdmin(nv);
        if (res) {
          this.msgSuccess("删除成功");
          this.getData();
        }
      });
    },
    reset(row) {
      this.resetPwd.visible = true;
      this.resetPwd.row = row;
    },
    showPermission(row) {
      this.adminPermission.visible = true;
      this.adminPermission.row = row;
    },
    getData() {
      this.$refs["vueTable"].refresh();
    },
  },
}
</script>

<style scoped>

</style>
